import Vue from 'vue'
import App from './App.vue'
import './permission'; //权限验证
import router from './router/index';
import store from './store';
//助手函数
import $help from './help';
Vue.prototype.$help = $help;
//图表
import VCharts from 'v-charts';
Vue.use(VCharts);
//ELEUI 引入
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/style.scss';
import VueSocketIO from 'vue-socket.io';
import dayjs from 'dayjs';
Vue.prototype.dayjs = dayjs;
Vue.use(ElementUI, {size: 'medium'});
// 光滑线条
import echarts from 'echarts'
Vue.prototype.$echarts = echarts


import Print from 'vue-print-nb'
Vue.use(Print);



//地图和编辑器引入
import VueAMap from 'vue-amap';
VueAMap.initAMapApiLoader({
    key: '1e3ab409e5ae99075d7d0cc20632a3ca',
    // plugin: ['AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType'],
    plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
    v: '1.4.4',
    uiVersion: '1.0.11' // 版本号
});
Vue.use(VueAMap);

import VueClipboard from 'vue-clipboard2';
VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);
Vue.config.productionTip = false;






new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
